import { createFileRoute } from '@tanstack/react-router'
import { Layout } from '@/shared/wrappers/Layout'
import { Button } from '@/ui/button'
import { useNavigate } from '@tanstack/react-router'
import { cn } from '@/shared/lib/utils'
import { StarfieldBackground } from '@/ui/starfield-background'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/not-found')({
  component: NotFound,
})

function NotFound() {
  const { t } = useTranslation('app')
  const navigate = useNavigate()
  return (
    <Layout
      className="flex flex-col gap-6 items-center justify-center"
      safeX="safe"
      safeY="safe"
      width={'full'}
      height={'full-height'}
    >
      <StarfieldBackground amount={300} speed={8} scrollBoost={4} />
      <div className="flex flex-col items-center text-center justify-center gap-2">
        <h1 className="text-x28 font-bold">{t('not_found.title')}</h1>
        <p className=" text-x18 text-[#8c8c8c] max-w-[65%]">
          {t('not_found.title')}
        </p>
      </div>
      <Button
        variant="primary"
        size="md"
        className={cn(' px-8 ')}
        onClick={() => navigate({ to: '/' })}
      >
        {t('not_found.not_found_button')}
      </Button>
    </Layout>
  )
}
export default NotFound
